import axios from 'axios';

export const PartnerList = (params) => async () => {
  return await axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/partners`,
    { params }
  ).then(response => {
    return Promise.resolve(response);
  }).catch( e => {
    return Promise.reject(e)
  });
};